import GallerySlider from '@components/components/Slider/GallerySlider/GallerySlider';
import Container from '@components/components/Container/Container';
import React from 'react';

const CmsGalleryExtended = ({ headingLevel, slides, isSmall, hasLightbox }) => (
  <Container size={isSmall ? 'md' : 'lg'}>
    <GallerySlider
      hasLightbox={hasLightbox}
      headingLevel={headingLevel}
      images={slides}
      isExtended
    />
  </Container>
);

export default CmsGalleryExtended;
